enum ElectronAppFeature {
    Popout = "popout",
    Webviews = "webviews",
    SPA = "SPA",
    XDPlugin = "xdPlugin",
    NewFigmaSSOFlow = "newFigmaSSOFlow",
    NewGoogleSSOFlow = "newGoogleSSOFlow",
    NewSlackIntegrationFlow = "newSlackIntegrationFlow",
    NewSSOFlow = "newSSOFlow",
    NativeContextMenu = "nativeContextMenu",
    MFALogin = "MFALogin",
    AppMenu = "appMenu",
    MultiWindow = "multiWindow",
    DesignRefresh2024 = "designRefresh2024",
    ImportPNGs = "importPNGs",
    DragRegions = "dragRegions",
    UpdateUseDesktopAppForLinks = "updateUseDesktopAppForLinks",
    EnableAIOrganizationAnimation = "enableAIOrganizationAnimation",
}

export default ElectronAppFeature;
